var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConditionIconRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 537,
    height: 345,
    viewBox: "0 0 537 345",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M653.066 316C431.289 114 316.642 471.5 292.679 249.5C274.647 82.4505 145.14 117 6.9995 30",
    stroke: "#F9E9E2",
    strokeWidth: 26
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M677.5 337C485.794 72 306.353 431.5 314.811 254C323.269 76.5 100.034 69 17.807 11",
    stroke: "white",
    strokeWidth: 26
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditionIconRight);
export default __webpack_public_path__ + "static/media/condition_icon_right.855799ad23eed924944171e374339545.svg";
export { ForwardRef as ReactComponent };